import { Integration_Service_Names_Enum } from '@main/graphql/types.admin.generated';

import { IntegrationService } from '../../../../lib';
import { QualysConnector } from '../../connector';

export const QualysService = IntegrationService.make({
  connector: QualysConnector,
  name: Integration_Service_Names_Enum.Qualys,
});
